import { useEffect, useState } from "react";
import { getRequestedCurrency } from "../currency/currencies";
import { CurrencyData } from "../models/financial";

export function useCustomerCurrency() {
  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyData>();

  useEffect(() => {
    const selectedCustomer = localStorage.getItem('errea_selectedCustomer')
      ? JSON.parse(localStorage.getItem('errea_selectedCustomer') as string)
      : null;

    if (selectedCustomer) {
      let currency;
      if (selectedCustomer.currencyCode)
        currency = getRequestedCurrency(selectedCustomer.currencyCode);
      else
        currency = getRequestedCurrency('EUR');

      if (currency)
        setSelectedCurrency(currency);
    }
  }, [])

  return {
    currency: selectedCurrency ? selectedCurrency.symbol : '€',
    code: selectedCurrency ? selectedCurrency.code : 'EUR'
  }
  
}